import { Button, Tooltip, Spin } from "antd";
import * as React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { EyeOutlined } from "@ant-design/icons";
import TableWrap from "../common/Table";
import { ViewRedeemCodeDownload } from "./ViewRedeemCodeDownload";
import { dateFormat } from "../../utils/general";

class CardRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      uploadRedeemData: null,
      isShowOTP: false,
      cardId: "",
      otpVerifyToken: "",
      isOpenRedeemModal: false,
      pagination: {
        pageSize: 10,
        current: 1,
      },
      userPermission: {
        edit: false,
        delete: false,
      },
    };

    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedCards = this.getLimitedCards.bind(this);
  }

  async componentDidMount() {
    this.setState({ data: this.props.data, isLoading: false });

    const { access_permission } = this.props.loginUserData;
    if (access_permission) {
      const permission = JSON.parse(access_permission);
      this.setState({
        userPermission: {
          edit: permission?.card?.edit || false,
          delete: permission?.card?.delete || false,
        },
      });
    }
  }

  async getLimitedCards(pagination) {
    const { searchText } = this.props;
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState({ isLoading: true }, async () => {
      if (searchText) {
        this.listSearchCardData(start, end);
      } else {
        this.props.loadTable(start, end);
      }
    });
  }

  handleTableChange(pagination) {
    this.setState({ pagination }, () => this.getLimitedCards(pagination));
  }
  handleDeleteRedeemCodeModalclose() {
    this.setState({
      uploadRedeemData: null,
      isOpenRedeemModal: false,
    });
  }

  columns = [
    {
      title: "Sr. No.",
      key: "serial_number",
      render: (text, item, index) => <span>{index + 1}</span>,
    },
    {
      title: "Batch id",
      key: "id",
      render: (text, item) => <strong>{item?.id || "-"}</strong>,
    },
    {
      title: "Name",
      key: "name",
      render: (text, item) => <strong>{item?.card?.name || "-"}</strong>,
    },
    {
      title: "Arabic Name",
      key: "arabic_name",
      render: (text, item) => <strong>{item?.card?.arabic_name || "-"}</strong>,
    },

    {
      title: "Deleted Count",
      key: "deleted_count",
      render: (text, item) => <strong>{item?.deleted_count || "-"}</strong>,
    },
    {
      title: "Downloaded Date",
      key: "deleted_count",
      render: (text, item) => (
        <strong>{dateFormat(item?.createdAt) || "-"}</strong>
      ),
    },

    {
      title: "Actions",
      key: "action",
      render: (text, item) => (
        <Tooltip title="View">
          <Button
            shape="circle"
            icon={<EyeOutlined />}
            onClick={() => {
              this.setState({
                uploadRedeemData: item,
                isOpenRedeemModal: true,
              });
            }}
          />
        </Tooltip>
      ),
    },
  ];

  render() {
    const { isLoading, uploadRedeemData, isOpenRedeemModal } = this.state;
    const { authToken } = this.props;

    if (isLoading) {
      return (
        <div style={{ marginLeft: "20px" }}>
          <Spin
            size="large"
            style={{ marginLeft: "480px", marginTop: "130px" }}
          />
        </div>
      );
    }
    return (
      <div style={{ overflowX: "auto" }}>
        <TableWrap
          data={this.props.data}
          columns={this.columns}
          isLoading={isLoading}
          total={this.props.totalRecords}
          pagination={this.state.pagination}
          handleTableChange={this.handleTableChange}
          scroll={{ x: 800 }}
        />

        {isOpenRedeemModal && (
          <ViewRedeemCodeDownload
            admin={false}
            // onClose={() => this.setState({ isOpenRedeemModal: false })}
            onClose={this.handleDeleteRedeemCodeModalclose.bind(this)}
            uploadRedeemData={uploadRedeemData}
            isVisible={isOpenRedeemModal}
            authToken={authToken}
            loginUserData={this.props.loginUserData}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

const mapDispatchToProps = (dispatch) => ({
  setLoginFlag: (flag) => dispatch({ type: "SET_LOGIN_FLAG", flag }),
  setUserData: (userData) => dispatch({ type: "SET_USER_DATA", userData }),
  setUserToken: (authToken) =>
    dispatch({ type: "SET_USER_AUTHTOKEN", authToken }),

  setListCardDataTotal: (listCardDataTotal) =>
    dispatch({ type: "SET_LIST_CARD_DATA_TOTAL", listCardDataTotal }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CardRecordsTable));
